import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  TabContent,
  TabPane,
  NavItem,
  Nav,
  Button,
  Row,
  Col
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { Separator } from '../../../../../../components/common/CustomBootstrap';
import { API_GenerateRoomURL } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import '../../style/style.css';
import SEOSettings from './SEOSettings';
import URLParamSettings from './URLParamSettings';
import RoomsRange from './RoomsRange';
import GenerateQRCode from './GenerateQRCode';
import QRCodePlaceholder from '../../../../../../assets/QRCodePlaceholder.png';


export default function StandaloneCodeSnippet({ integration, propertyId, saveIntegration, integrationProperties }) {
  const [activeTab, setActiveTab] = useState('seo');
  const [roomUrlList, setRoomUrlList] = useState([]);
  const [queryString, setQueryString] = useState("");

  useEffect(() => {
    if (integration.standalonePage.pageSettings.urlParams !== null && integration.standalonePage.pageSettings.urlParams.urlQueryString !== null) {

      setQueryString(integration.standalonePage.pageSettings.urlParams.urlQueryString);
    }
  }, [integration]);

  const toggleMenu = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (tab === "qrcode") {
        LoadRoomNumberList();
      }
    }
  };

  const handleChangeQueryString = (e) => {
    setQueryString(e.target.value);
  }

  const LoadRoomNumberList = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_GenerateRoomURL}/get-room-urls/${integration.id}?groupId=${getGroupID()}`,
    })
      .then((res) => {
        setRoomUrlList(res.data);
      })
      .catch((err) => console.log('err', err));
  }
  const handleGenerateRoomURL = () => {
    const pageSettings = integration.standalonePage.pageSettings;
    if (pageSettings !== null &&
      pageSettings.roomNumberRange !== null &&
      pageSettings.roomNumberRange.length > 0) {
      AxiosAPI({
        method: 'post',
        url: API_GenerateRoomURL + "/generate-room-urls",
        data: {
          groupId: getGroupID(),
          integrationId: integration.id,
          compendiumUrlPath: pageSettings.seoSettings.ownUrl,
          queryString: queryString,
          roomsRange: pageSettings.roomNumberRange
        },
      }).then(res => {
        LoadRoomNumberList();
      });
    }
  }
  const handleGenerateQRCode = () => {
    const pageSettings = integration.standalonePage.pageSettings;
    AxiosAPI({
      method: 'put',
      url: API_GenerateRoomURL + "/generate-qrcode",
      data: {
        groupId: getGroupID(),
        integrationId: integration.id,
        qrCodeLogo: pageSettings.qrCodeLogo
      },
    }).then(res => {
      LoadRoomNumberList();
    });
  }

  const deleteUrl = (id, allDelete) => {
    var body = {
      id: id,
      integrationId: integration.id,
      groupId: getGroupID(),
      isDeleteAll: allDelete
    }
    AxiosAPI({
      method: 'delete',
      url: API_GenerateRoomURL + "/delete-room-url",
      data: body,
    }).then(res => {
      LoadRoomNumberList();
    });
  }

  const saveQueryString = () => {
    const pageSettings = integration.standalonePage.pageSettings;
    if (queryString !== null && queryString !== "") {
      var stringbody = {
        ...pageSettings.urlParams,
        urlQueryString: queryString
      }
      pageSettings.urlParams = stringbody;
      saveIntegration({ PageSettings: pageSettings });
    }
  }
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody name="bodyClick text-center">
          <div className="col-md-12 text-center">
            <h4>Publish your Digital Compendium</h4>
            <p className="mb-3">
              Define SEO settings and create your unique URL
            </p>
          </div>
          <Separator className="mb-2" />
          <Nav tabs className="separator-tabs ml-0 mr-0">
            <NavItem className="w-20 text-center">
              <NavLink
                style={{ marginRight: "0px" }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'seo',
                  'nav-link': true,
                })}
                onClick={() => toggleMenu('seo')}
              >
                SEO Settings
              </NavLink>
            </NavItem>
            <NavItem className="w-20 text-center">
              <NavLink
                style={{ marginRight: "0px" }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'urlparam',
                  'nav-link': true,
                })}
                onClick={() => toggleMenu('urlparam')}
              >
                URL Params
              </NavLink>
            </NavItem>
            <NavItem className="w-20 text-center">
              <NavLink
                style={{ marginRight: "0px" }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'roomno',
                  'nav-link': true,
                })}
                onClick={() => toggleMenu('roomno')}
              >
                Room Numbers
              </NavLink>
            </NavItem>
            <NavItem className="w-25 text-center">
              <NavLink
                style={{ marginRight: "0px" }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'qrcode',
                  'nav-link': true,
                })}
                onClick={() => toggleMenu('qrcode')}
              >
                Generate OR Codes
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="seo">
              <SEOSettings
                pageSettings={integration.standalonePage.pageSettings}
                integration={integration}
                propertyId={propertyId}
                saveIntegration={saveIntegration}
              />
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="urlparam">
              <URLParamSettings
                pageSettings={integration.standalonePage.pageSettings}
                integration={integration}
                propertyId={propertyId}
                saveIntegration={saveIntegration}
                integrationProperties={integrationProperties}
              />
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="roomno">
              <RoomsRange
                pageSettings={integration.standalonePage.pageSettings}
                integration={integration}
                propertyId={propertyId}
                saveIntegration={saveIntegration}
                integrationProperties={integrationProperties}
              />
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="qrcode">
              <Row>
                <Col className='col-md-12 mt-3'>
                  <Button
                    color="primary"
                    size="xs"
                    className="mr-1"
                    outline
                    onClick={() => handleGenerateRoomURL()}
                  >
                    + Generate URLs for Rooms
                  </Button>
                  <Button
                    color="primary"
                    size="xs"
                    className="mr-1"
                    outline
                    onClick={() => handleGenerateQRCode()}
                  >
                    + Generate QR Codes for Rooms
                  </Button>
                  <Separator className="mb-2 mt-2" />
                </Col>
              </Row>
              {roomUrlList !== null && roomUrlList.length > 0 ?
                <GenerateQRCode
                  pageSettings={integration.standalonePage.pageSettings}
                  propertyId={propertyId}
                  urlsList={roomUrlList}
                  queryString={queryString}
                  handleChangeQueryString={handleChangeQueryString}
                  deleteUrl={deleteUrl}
                  saveQueryString={saveQueryString}
                ></GenerateQRCode>
                :
                <Row>
                  <Col className="col-md-12 text-center">
                    <img src={QRCodePlaceholder} className="w-80"></img>
                  </Col>
                </Row>
              }
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Fragment>
  );
}
